// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import AppLayout from "@/components/sepsis/AppLayout";
import ProtectedRoute from "@/components/sepsis/ProtectedRoute";
import OverviewPage from "@/pages/OverviewPage";
import SimulatorPage from "@/pages/SimulatorPage";
import ConfigPage from "@/pages/ConfigPage";
import LoginPage from "@/pages/LoginPage";
import ApiDocsPage from "@/pages/ApiDocsPage";
import TransactionsPage from "@/pages/TransactionsPage";
import AccuracyPage from "@/pages/AccuracyPage";
import { AuthProvider } from "@/auth/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export default function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<AppLayout />}>
                  <Route index element={<OverviewPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/developers" element={<ApiDocsPage />} />
                  <Route
                    path="/simulator"
                    element={
                      <ProtectedRoute>
                        <SimulatorPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/config"
                    element={
                      <ProtectedRoute>
                        <ConfigPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/transactions"
                    element={
                      <ProtectedRoute>
                        <TransactionsPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/accuracy"
                    element={
                      <ProtectedRoute>
                        <AccuracyPage />
                      </ProtectedRoute>
                    }
                  />
                </Route>
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </GoogleOAuthProvider>
      </LanguageProvider>
    </div>
  );
}
